// Conversion funnel: horizontal bars, one per step, width proportional to the
// share of the top step. Single measure across ordinal steps, so one hue
// (accent) — not a categorical palette. Pure CSS widths, SSR-safe.

export type FunnelStep = {
  key: string;
  label: string;
  count: number;
  pct_of_top: number;
  pct_of_prev: number | null;
};

function formatNumber(n: number) {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function Funnel({ steps }: { steps: FunnelStep[] }) {
  const hasData = (steps[0]?.count ?? 0) > 0;

  if (!hasData) {
    return (
      <div className="flex h-32 items-center justify-center rounded-lg border border-hairline bg-page">
        <p className="text-sm text-ink-muted">No funnel activity in this range yet.</p>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-hairline bg-page p-4">
      <div className="space-y-3">
        {steps.map((step, i) => (
          <div key={step.key}>
            {i > 0 && step.pct_of_prev !== null && (
              <div className="mb-1.5 pl-1 text-xs text-ink-muted">
                ↓ {step.pct_of_prev}% continued
              </div>
            )}
            <div className="flex items-baseline justify-between text-sm">
              <span className="text-ink-body">{step.label}</span>
              <span className="tabular-nums text-ink-muted">
                <span className="font-medium text-ink-display">
                  {formatNumber(step.count)}
                </span>{" "}
                · {step.pct_of_top}%
              </span>
            </div>
            <div className="mt-1 h-3 w-full overflow-hidden rounded-full bg-surface">
              <div
                className="h-full rounded-full bg-accent"
                style={{ width: `${Math.max(step.pct_of_top, 1.5)}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
